<template>
    <div>
        <component-loader
            :key="$i18n.locale"
            v-if="componentInitialized"
            :component-name="componentName"
            :default-component-name="defaultComponentName"
            id="monitoring-component"
        >
        </component-loader>
        <div class="clearance-box mt-5 row">
            <div class="col-12 pl-0 pr-0">
                <div class="clearance-bar">
                    <label>{{ $t('monitoring.title_clearance_box') }}</label>
                    <radio name="report.clearance"
                        class="form-check-inline"
                        value="cleared-with-condition"
                        v-model="MonitoringForm.report.clearance"
                        :disabled="(loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN) || !MonitoringForm.isEditable"
                        >
                        <label>{{ $t('monitoring.field_title_cleared_under_conditions') }}</label>
                    </radio>
                    <radio name="report.clearance"
                        class="form-check-inline"
                        value="cleared"
                        v-model="MonitoringForm.report.clearance"
                        :disabled="(loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN) || !MonitoringForm.isEditable"
                        >
                        <label>{{ $t('monitoring.field_title_cleared') }}</label>
                    </radio>
                    <radio name="report.clearance"
                        class="form-check-inline"
                        value="not-cleared"
                        v-model="MonitoringForm.report.clearance"
                        :disabled="(loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN) || !MonitoringForm.isEditable"
                        >
                        <label>{{ $t('monitoring.field_title_not_cleared') }}</label>
                    </radio>
                </div>
                <comment-box
                    class="form-group"
                    v-model="MonitoringForm.report.clearance_comments"
                    :is-editable="(loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN) && MonitoringForm.isEditable"
                    :comments="MonitoringForm.report.clearance_comments"
                    :pull-right="false">
                </comment-box>
                <base-button
                    v-if="(loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN) && MonitoringForm.isEditable"
                    type="primary"
                    class="validate-report pull-right mb-3 mr-3"
                    @click="validateReport"
                    >
                    Validate Report
                </base-button>
            </div>
        </div>

        <upload-file
            v-if="(loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN) && MonitoringForm.report_type === 'financial'"
            v-model="MonitoringForm.files.financial['admin_report_' + reportId]"
            :section="'financial.admin_report_' + reportId"
            class="upload-report-box"
            :file-data="MonitoringForm.files.financial['admin_report_' + reportId]"
            :is-editable="MonitoringForm.isEditable"
            :is-monitoring="true"
            >
            <div class="row">
                <div class="col-lg-12 upload-report-inner-box">
                    <h4>{{ $t('monitoring.button_title__upload_financial_checklist') }}</h4>
                </div>
            </div>
        </upload-file>

        <div class="row mt-5" v-if="MonitoringForm.initialized && MonitoringForm.isEditable">
            <div class="col-12">
                <base-button type="default" wide @click.native="saveProgress">{{$t('general.save_progress')}}</base-button>
                <base-button class="pull-right" wide @click.native="submitt">{{$t('general.submit')}}</base-button>
            </div>
        </div>
    </div>
</template>
<script>
    import ComponentLoader from './ComponentLoader';
    import {MonitoringService, CallService, UserRoles, FileUploadService, MonitoringForm} from '@/services';
    import {EventBus} from '@/event-bus.js';
    import {CommentBox} from 'src/components';
    import swal from 'sweetalert2';

    export default
    {
        components:
        {
            ComponentLoader,
            CommentBox,
        },
        data()
        {
            return {
                UserRoles,
                MonitoringForm,
                callId: parseInt(this.$route.params.callId) || null,
                proposalId: parseInt(this.$route.params.proposalId) || null,
                reportId: parseInt(this.$route.params.reportId) || null,
                componentInitialized: false,
                componentName: 'Dynamic',
                defaultComponentName: 'Default',
            }
        },
        async beforeCreate()
        {
            const vm = this;
            const loader = vm.$loading.show();

            vm.loggedUser = vm.$store.getters['Auth/loggedUser'];

            const callId = parseInt(vm.$route.params.callId);
            const proposalId = parseInt(vm.$route.params.proposalId);
            const reportId = parseInt(vm.$route.params.reportId);
            const objectAssignDeep = require('object-assign-deep');

            MonitoringForm.init();

            MonitoringForm.reportId = reportId;
            MonitoringForm.callId = callId;
            MonitoringForm.proposalId = proposalId;

            await CallService.get(callId).then((response) =>
            {
                MonitoringForm.model = {grant_agreement: {}, logical: {}, technical: {}, monthly: {}, financial: {}};
                MonitoringForm.files = {grant_agreement: {}, logical: {}, technical: {}, monthly: {}, financial: {}};
                MonitoringForm.report = {technical: {}, monthly: {}, financial: {}};
                MonitoringForm.report.files = {technical: {}, monthly: {}, financial: {}};

                vm.componentName = response.data.componentName.replace('index', 'report');
                vm.componentInitialized = true;
            });

            MonitoringForm.initialized = false;
            MonitoringForm.isEditable = false;

            await MonitoringService.getReport(reportId).then((response) =>
            {
                MonitoringForm.report = objectAssignDeep(MonitoringForm.report, response.data.data);
                MonitoringForm.report_type = response.data.report_type;
                // MonitoringForm.report.status = response.data.locked ? 'LOCKED;
                MonitoringForm.report.files = {...MonitoringForm.report.files, ...response.data.files};

                MonitoringForm.report.start_date = response.data.start_date;
                MonitoringForm.report.end_date = response.data.end_date;
            });

            await MonitoringService.getAwardedProposal({
                callId: callId,
                proposalId: proposalId
            }).then((response) =>
            {
                MonitoringForm.model = objectAssignDeep(MonitoringForm.model, response.data.data);
                MonitoringForm.files = {...MonitoringForm.files, ...response.data.files};

                MonitoringForm.title = response.data.title;
                MonitoringForm.organisation = response.data.organisation;
                MonitoringForm.reference = response.data.reference;

                MonitoringForm.initialized = true;
                MonitoringForm.isEditable = !MonitoringForm.report.locked;
            });

            loader.hide();
        },
        mounted()
        {
            const vm = this;

            // EventBus.$off('monitoring-save-progress');
            // EventBus.$on('monitoring-save-progress', data => { vm.saveProgress(); });

            // EventBus.$off('monitoring-submit');
            // EventBus.$on('monitoring-submit', data => { vm.submitt(); });
        },
        methods:
        {
            async saveProgress(status)
            {
                const vm = this;
                const loader = vm.$loading.show();

                await MonitoringService.updateReport({
                    reportId: MonitoringForm.reportId,
                    model: MonitoringForm.report,
                    status: status,
                    period:vm.$route.params.key
                }).then((response) =>
                {
                    if (status === 'lock')
                    {
                        MonitoringForm.isEditable = false;
                    }

                    if (status === 'submit')
                    {
                        swal({
                            title: this.$t('general.notification__success'),
                            html: this.$t('monitoring.notification__report_submitted').split("\n").join("<br>"),
                            buttonsStyling: false,
                            confirmButtonClass: 'btn btn-primary btn-fill',
                            // type: 'success'
                        });

                        MonitoringForm.isEditable = false;
                        MonitoringForm.report.status = 'LOCKED';
                        MonitoringForm.report.locked = true;

                        vm.$forceUpdate();
                    }
                });

                await vm.uploadFiles();

                loader.hide();
            },

            async submitt()
            {
                this.saveProgress('submit');
            },

            async uploadFiles()
            {
                const vm = this;
                let files = MonitoringForm.report.files;
                let promises = [];
                let section;
                let sub_section;

                for (section in files)
                {
                    if (files.hasOwnProperty(section))
                    {
                        for (sub_section in files[section])
                        {
                            if (files[section].hasOwnProperty(sub_section))
                            {
                                let file_to_upload = files[section][sub_section];

                                if (file_to_upload instanceof File)
                                {
                                    let form_data = new FormData();

                                    form_data.append('file', file_to_upload);
                                    //added on 22/03/22 by Sooraj K to set section textbox value from sub_section when value getting as null
                                    if (file_to_upload.section.endsWith('_')) 
                                    {
                                        form_data.append('section','financial.'+sub_section);
                                    }
                                    else
                                    {
                                        form_data.append('section', file_to_upload.section);
                                    }
                                    // end of adding.
                                    
                                    form_data.append('$section', section);

                                    if (file_to_upload.id)
                                    {
                                        form_data.append('id', file_to_upload.id);
                                    }

                                    let promise = FileUploadService.uploadMonitoringReportFiles({
                                        reportId: MonitoringForm.reportId,
                                        formData: form_data
                                    }).then((response) =>
                                    {
                                        const fd_section = form_data.get('$section');
                                        const fd_sub_section = form_data.get('$sub_section');

                                        files[fd_section][fd_sub_section] =
                                        {
                                            id: response.data.id,
                                            name: response.data.filename,
                                            download: response.data.download
                                        };
                                    }).catch((error) => console.log('error: ', error));

                                    promises.push(promise);
                                }
                            }
                        }
                    }
                }

                return await Promise.all(promises);
            },

            async validateReport()
            {
                MonitoringForm.report.locked = true;
                MonitoringForm.report.status = 'LOCKED';

                this.saveProgress('lock');
            },
        },
    };
</script>
